import { api } from "api/api";
import { AxiosError } from "axios";
import MotivoParada from "model/meta/producao/MotivoParada";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class MotivoParadaService implements BaseServiceCadastros<MotivoParada> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/motivoParada/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<MotivoParada>((resolve, reject): void => {
            api
                .get(`/motivoParada/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(motivoParada: MotivoParada) {
        return new Promise<MotivoParada>((resolve, reject): void => {
            api
                .post(`/motivoParada/incluir`, JSON.stringify(motivoParada))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(motivoParada: MotivoParada) {
        return new Promise<MotivoParada>((resolve, reject): void => {
            api
                .put(`/motivoParada/editar`, JSON.stringify(motivoParada))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/motivoParada/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default MotivoParadaService;